import { axiosCustomerV3 } from 'modules/axios'
import { CONFIG } from './environments'

export function fetchCustomerFromV3API(accountId) {
  return axiosCustomerV3({
    method: 'GET',
    url: `${CONFIG.api.customers}/${accountId}`,
  }).then(resp => resp.data)
}
